export const MONTHS_NAMES_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

export const DAY_NAMES_SHORT = ["S", "M", "T", "W", "T", "F", "S"];
